import {useEffect, useCallback} from 'react';
import {fetchSmartEngageDataThunk} from '@ibibo/hotels-smartengage-store';
import {useDispatch, useSelector} from 'react-redux';
import {apiConfig} from '@ibibo/hotels-config';
import {commonSelectorFn} from '../common/redux/selectors';

const SmartEngageApiContainer = ({page}) => {
  const dispatch = useDispatch();
  const {
    homePageLandingWithCityId,
    homePageLanding,
    srpLanding,
    detailsLanding,
  } = apiConfig.smartEngageApiConfig;
  const {destination, checkin, checkout, roomString} = useSelector(commonSelectorFn);
  const {_id: cityId} = destination;

  const getConfig = () => {
    switch (page) {
      case 'home':
        if (cityId) return homePageLandingWithCityId;
        else return homePageLanding;
      case 'SRP':
        return srpLanding;
      case 'Details':
        return detailsLanding;
      default:
        return null;
    }
  };

  const fetchSmartEngageDataThunkCaller = useCallback(
    config => {
      return dispatch(fetchSmartEngageDataThunk(config, true));
    },
    [dispatch],
  );

  useEffect(() => {
    const config = getConfig();

    if (config) fetchSmartEngageDataThunkCaller(config);
  }, [cityId, checkin, checkout, roomString, page]);

  return null;
};

export default SmartEngageApiContainer;
